import type { KincodeGoogleCredential } from '@/auth/core/googleSsoTypes';

/**
 * Build the credential payload coolture_auth accepts for Google SSO.
 * Prefers id_token when available.
 * @param {string | null | undefined} idToken
 * @param {string | null | undefined} accessToken
 * @returns {KincodeGoogleCredential | null}
 */
export function buildKincodeGoogleCredential(
  idToken: string | null | undefined,
  accessToken: string | null | undefined
): KincodeGoogleCredential | null {
  if (typeof idToken === 'string' && idToken.trim().length > 0) {
    return { id_token: idToken.trim() };
  }

  if (typeof accessToken === 'string' && accessToken.trim().length > 0) {
    return { access_token: accessToken.trim() };
  }

  return null;
}
